import React, { useEffect, useState, useCallback, useRef, act } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getChatTopicHistoryAPI,
  getStarterQuestionsAPI,
  getTopicChatsAPI,
  setRenameChatHistoryAPI,
  setSearchChatHistoryAPI,
} from "../../redux/actions/ChatWithData/ChatWithDataApi";
import {
  setBrandsInChatWithData,
  setChattopicsHistory,
  setChatWithDataResponse,
  setDurationInChatWithData,
  setSelectedChatData,
} from "../../redux/actions/ChatWithData/ChatWithData";
import CollapseIcon from "../../assets/ChatWithData/collapse_icon.svg";
import BlackNewChatIcon from "../../assets/ChatWithData/black_new_chat_icon.svg";
import chatNameAccordionIcon from "../../assets/ChatWithData/chat_name_accordion_icon.svg";
import downAccordian from "../../assets/ChatWithData/accordian_down.svg";
import { Button, Tooltip, Collapse, Input, Popover, Spin } from "antd";
import isEqual from "react-fast-compare";
import { setOptionHighChart } from "../../redux/actions/HighChart";
import BoltIcon from "../../assets/ChatWithData/bolt_icon.svg";
import whiteNewChatIcon from "../../assets/ChatWithData/white_note_edit_icon.svg";
import BlueNewChatIcon from "../../assets/ChatWithData/blue_note_edit_icon.svg";
import openSidebarBlueIcon from "../../assets/ChatWithData/open_sidebar_blue_icon.svg";
import closeSidebarWhiteIcon from "../../assets/ChatWithData/close_sidebar_white_icon.svg";
import getFreeCreditsIcon from "../../assets/ChatWithData/get_free_credits_icon.svg";
import { useNavigate } from "react-router-dom";
import useDebounce from "../utils/useDebounce";
import { SearchOutlined } from "@ant-design/icons";
import threeDotIcon from "../../assets/ChatWithData/chat_name_options_icon.svg";
import chatShareOptionIcon from "../../assets/ChatWithData/chat_share_option_icon.svg";
import chatEditOptionIcon from "../../assets/ChatWithData/chat_edit_option_icon.svg";
import chatDeleteOptionIcon from "../../assets/ChatWithData/chat_delete_option_icon.svg";
import { LoadingOutlined, EditOutlined } from "@ant-design/icons";
import CustomModal from "./CustomModal";
import sidebarSearchIcon from "../../assets/ChatWithData/sidebar_search_icon.svg";
import SearchModal from "./SearchModal";

const { Panel } = Collapse;

const SideBar = ({
  isShowChatHistorySidebar,
  setIsShowChatHistorySidebar,
  text,
  setText,
  showNavbar,
  setShowNavbar,
  searchModalEnabled,
  setSearchModalEnabled,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state?.ApiCall?.brandlogicalgroup?.data?.result
  );
  const competitorBrands = useSelector(
    (state) => state?.WidgetAPI?.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state?.attributes?.temporary_words
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const chatWithData = useSelector((state) => state?.ChatWithData);

  const chatTopicsHistory = useSelector(
    (state) => state?.ChatWithData?.chat_topics_history
  );
  const selectedChatTopics = useSelector(
    (state) => state?.ChatWithData?.selected_chat_data
  );
  const chatHistoryLoader = useSelector(
    (state) => state?.ChatWithData?.chat_history_loader
  );
  const chatsAnswerLoader = useSelector(
    (state) => state?.ChatWithData?.chats_answer_loader
  );
  const userProfileDetails = useSelector(
    (state) => state?.ChatWithData?.user_profile_details
  );
  const topicAnswerLoader = useSelector(
    (state) => state?.ChatWithData?.topic_answer_loader
  );
  const chatsStreamLoader = useSelector(
    (state) => state?.ChatWithData?.chats_stream_loader
  );
  const followUpQuestionsLoader = useSelector(
    (state) => state?.ChatWithData?.follow_up_questions_loader
  );
  const starterQuestionsList = useSelector(
    (state) => state?.ChatWithData?.starter_questions
  );
  const scrollContainerRef = useRef(null); // Ref to the scroll container

  // console.log("chatTopicsHistory", chatTopicsHistory);
  let chatTopicsHistoryList = chatTopicsHistory?.data?.length
    ? chatTopicsHistory?.data
    : chatTopicsHistory?.persist_data;

  let ip_address = localStorage.getItem("ipAddress");
  let visitor_id = localStorage.getItem("visitor_id");
  let p_token = localStorage.getItem("p_token");
  const is_subscription_active = localStorage.getItem("is_subscription_active");
  let is_locobuzz_user = localStorage.getItem("is_locobuzz_user");

  // const [text, setText] = useState("");
  const [showCustomModal, setShowCustomModal] = useState({
    flag: false,
    title: null,
    sub_title: null,
    option: null,
  });
  const [showOptionPopUp, setShowOptionPopUp] = useState({
    index: null,
    text: null,
    flag: false,
    text_id: null,
  });
  const [showThreeDotIcon, setShowThreeDotIcon] = useState({
    index: null,
    text: null,
    flag: false,
    text_id: null,
  });
  const [chatSessionId, setChatSessionId] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [editedChatName, setEditedChatName] = useState(null);
  const [enabledEditChat, setEnabledEditChat] = useState({
    flag: false,
    session_id: null,
    text: null,
  });
  const debouncedUpdateTitle = useDebounce(searchText, 1000);

  const [upgradePlanText, setUpgradePlanText] = useState("");
  // const [searchModalEnabled, setSearchModalEnabled] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  let isDataLoading =
    chatsStreamLoader ||
    topicAnswerLoader ||
    chatsAnswerLoader ||
    followUpQuestionsLoader;

  useEffect(() => {
    setUpgradePlanText("Using " + userProfileDetails?.payment_info?.plan_type);
  }, [userProfileDetails?.payment_info?.plan_type]);

  useEffect(() => {
    if (window.location.pathname === "/chat-with-data") {
      if (debouncedUpdateTitle) {
        // setSearchText(null);

        let payloadObj = {
          p_token: p_token ? p_token : null,
          search_text: searchText,
        };
        dispatch(setSearchChatHistoryAPI(payloadObj));

        // setDashboardList([]);
      } else {
        if (debouncedUpdateTitle === "") {
          let payloadObj = {
            authParams: authParams,
            offset: 0,
            session_id: null,
            p_token: p_token ? p_token : null,
          };
          dispatch(getChatTopicHistoryAPI(payloadObj));
          // setDashboardList([]);
        }
      }
    }
  }, [debouncedUpdateTitle]);

  // Scroll Logic
  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    let roundOffAdd = scrollTop + clientHeight + 1;

    // Check if the user has scrolled to the bottom
    if (
      roundOffAdd >= scrollHeight ||
      scrollTop + clientHeight >= scrollHeight
    ) {
      // console.log("Reached the bottom of the div");
      let count = 0;
      chatTopicsHistory?.data?.map((chat) => {
        chat?.content?.map((t) => {
          count = count + 1;
        });
      });

      if (chatTopicsHistory?.total_length > count && !chatHistoryLoader) {
        getNextChatHistoryApiCall();
      }
    }
  };

  // Scroll Logic
  const getNextChatHistoryApiCall = () => {
    let obj = {
      persist_data: chatTopicsHistory?.persist_data,
      total_length: chatTopicsHistory?.total_length,
      data: [],
    };
    dispatch(setChattopicsHistory(obj));

    let count = 0;
    chatTopicsHistory?.data?.map((chat) => {
      chat?.content?.map((t) => {
        count = count + 1;
      });
    });

    let payloadObj = {
      authParams: authParams,
      offset: count,
      chatTopicsHistory: chatTopicsHistory,
      p_token: p_token ? p_token : null,
    };
    dispatch(getChatTopicHistoryAPI(payloadObj));
  };

  const handleUpgradePlan = () => {
    navigate("/pricing");

    // Close Mobile sidebar
    if (showNavbar) {
      setShowNavbar(false);
    }
  };

  const handleCreateNewChat = () => {
    setText("");
    let obj = {
      persist_data: [],
      data: [],
      total_length: null,
    };
    dispatch(setChatWithDataResponse(obj));

    // Reset selected chat data
    dispatch(setSelectedChatData(null));

    // Close Mobile sidebar
    if (showNavbar) {
      setShowNavbar(false);
    }
    if (starterQuestionsList?.length === 0 && p_token) {
      let obj1 = {
        p_token: p_token ? p_token : null,
        visitor_id: p_token ? null : visitor_id ? visitor_id : null,
      };
      dispatch(getStarterQuestionsAPI(obj1));
    }
  };

  const handleGetTopicChats = (chat) => {
    if (chat?.session_id !== selectedChatTopics?.session_id) {
      setText("");

      // Reset State Highcharts
      dispatch(setOptionHighChart(null));

      // console.log("Inside handleGetTopicChats", chat?.session_id);
      let payloadObj = {
        authParams: authParams,
        session_id: chat?.session_id,
        offset: 0,
        brands: brands,
        p_token: p_token ? p_token : null,
      };
      // API Call
      dispatch(getTopicChatsAPI(payloadObj));

      // Store Selected chat data
      dispatch(setSelectedChatData(chat));

      // Close Mobile sidebar
      if (showNavbar) {
        setShowNavbar(false);
      }

      // Close edit input field
      setEnabledEditChat({
        flag: false,
        session_id: null,
        text: null,
      });
      // Close Option Pop Up
      setShowOptionPopUp({
        index: null,
        text: null,
        flag: false,
        text_id: null,
      });
      setShowThreeDotIcon({
        index: null,
        text: null,
        flag: false,
        text_id: null,
      });
    }
  };

  const toggleChatHistorySidebar = useCallback(() => {
    setIsShowChatHistorySidebar((prev) => !prev);
  }, []);

  const handleFreeCredits = () => {
    alert("Get Free Credits");
  };

  const onChange = (key) => {
    setActiveKey(key);
    // console.log(key);
  };

  const handleSearchChat = (text) => {
    setSearchText(text);
  };

  const handleOnMouseEnter = (index, text, text_id) => {
    if (!showOptionPopUp?.flag) {
      setShowThreeDotIcon({
        index: index,
        text: text,
        flag: true,
        text_id: text_id,
      });
    }
  };

  const handleOnMouseLeave = (index, text, text_id) => {
    if (!showOptionPopUp?.flag) {
      setShowThreeDotIcon({
        index: null,
        text: null,
        flag: false,
        text_id: null,
      });
      setShowOptionPopUp({
        index: null,
        text: null,
        flag: false,
        text_id: null,
      });
    }
  };

  const handleOpenChatOptionPopUp = (index, text, chat, text_id) => {
    setShowOptionPopUp({
      index: index,
      text: text,
      flag: true,
      text_id: text_id,
    });

    setShowThreeDotIcon({
      index: index,
      text: text,
      flag: true,
      text_id: text_id,
    });

    setChatSessionId(chat?.session_id);
  };

  const handlePopUpVisible = (flag) => {
    if (!flag) {
      setShowThreeDotIcon({
        index: null,
        text: null,
        flag: false,
        text_id: null,
      });
      setShowOptionPopUp({
        index: null,
        text: null,
        flag: false,
        text_id: null,
      });
    }
  };

  const handleChatShare = () => {
    alert("Share Chat");
  };

  const handleChatDelete = (session_id) => {
    setShowCustomModal({
      flag: true,
      title: "Delete this chat?",
      sub_title:
        "Are you sure you want to delete this chat? Once deleted, this conversation cannot be recovered.",
      option: "delete",
    });

    // Close Option Pop Up
    setShowOptionPopUp({
      index: null,
      text: null,
      flag: false,
      text_id: null,
    });
  };

  const handleChatEdit = () => {
    setEditedChatName(showOptionPopUp?.text);
    setEnabledEditChat({
      flag: true,
      session_id: chatSessionId,
      text: null,
    });
  };

  const optionsContent = (
    <div style={{ marginBottom: "-14px", marginTop: "5px" }}>
      {/* <p onClick={handleChatShare} style={{ cursor: "pointer" }}>
        <img src={chatShareOptionIcon} /> Share
      </p> */}
      <p onClick={handleChatEdit} className="chat-name-option-box">
        <EditOutlined
          style={{
            marginRight: "8px",
            fontSize: "20px",
          }}
        />
        {/* <img
          src={chatEditOptionIcon}
          style={{ marginRight: "5px", height: "20px" }}
          alt="chat Edit Option Icon"
        />{" "} */}
        Rename
      </p>
      <p onClick={handleChatDelete} className="chat-name-option-box">
        <img
          src={chatDeleteOptionIcon}
          style={{ marginRight: "5px", height: "20px" }}
          alt="chat Delete Option Icon"
        />{" "}
        Delete
      </p>
    </div>
  );

  const handleClearAllChat = () => {
    setShowCustomModal({
      flag: true,
      title: "Clear all chat?",
      sub_title:
        "Are you sure you want to delete all chat history? Once deleted, you will lose access to all previous conversations.",
      option: "delete_all",
    });
  };

  const handleEditedChatNameAPICall = (event) => {
    if (event.key === "Enter" || event.key === undefined) {
      if (editedChatName === "" || editedChatName === null) {
        // Do nothing
      } else {
        let payloadObj = {
          p_token: p_token ? p_token : null,
          session_name: editedChatName,
          session_id: chatSessionId,
          chat_list_api_obj: {
            offset: 0,
            session_id: null,
            p_token: p_token ? p_token : null,
          },
          chatTopicsHistory: chatTopicsHistory,
          total_length: chatTopicsHistory?.total_length,
        };
        dispatch(setRenameChatHistoryAPI(payloadObj));

        // Close Flag which enable the edit field
        setEnabledEditChat({
          flag: false,
          session_id: null,
          text: null,
        });

        // Close Option Pop Up
        setShowOptionPopUp({
          index: null,
          text: null,
          flag: false,
          text_id: null,
        });
        setShowThreeDotIcon({
          index: null,
          text: null,
          flag: false,
          text_id: null,
        });
      }
    }
  };

  const handleOnMouseEnter1 = (e) => {
    setUpgradePlanText("Upgrade Plan");
  };

  const handleOnMouseLeave1 = (e) => {
    setUpgradePlanText("Using " + userProfileDetails?.payment_info?.plan_type);
  };

  const handleSearchPopUp = () => {
    setSearchModalEnabled(true);

    // Close Mobile sidebar
    if (showNavbar) {
      setShowNavbar(false);
    }
  };

  return (
    <>
      <section className={`sidebar ${isDataLoading ? "fade-and-disable" : ""}`}>
        {p_token &&
        (window.location.pathname === "/chat-with-data" ||
          window.location.pathname?.startsWith("/share/id")) ? (
          <div className="sidebar_options_div">
            <Tooltip title="Close sidebar">
              <img
                className="desktop-close-sidebar-btn"
                style={{
                  cursor: "pointer",
                  // transform: "rotate(180deg)",
                }}
                src={closeSidebarWhiteIcon}
                onClick={toggleChatHistorySidebar}
                alt="desktop-close-sidebar-btn"
              />
            </Tooltip>
            {/* <div className="new_chat_btn_pipe"></div> */}
            <div className="new_chat_btn" onClick={handleCreateNewChat}>
              <img
                style={{ marginRight: "10px" }}
                src={whiteNewChatIcon}
                alt="Blue New Chat Icon"
              />
              New Chat
            </div>
            {/* <div className="new_search_btn_pipe"></div> */}
            <img
              className="sidebar-search-btn"
              src={sidebarSearchIcon}
              onClick={handleSearchPopUp}
              alt="Sidebar Search Icon"
            />
          </div>
        ) : (
          ""
        )}

        {/* Search Chat name */}
        {/* <Input
          prefix={
            <SearchOutlined style={{ color: "#4D5D89", marginRight: "10px" }} />
          }
          className="input-search-box"
          type="text"
          placeholder="Search chats"
          value={searchText}
          onChange={(e) => handleSearchChat(e?.target?.value)}
        /> */}

        {p_token &&
        (window.location.pathname === "/chat-with-data" ||
          window.location.pathname?.startsWith("/share/id")) ? (
          <div
            ref={scrollContainerRef}
            onScroll={handleScroll}
            // style={{ overflowY: "scroll", maxHeight: "100%" }}
            className="scroll-container sidebar-history custom_scroll1 h-100"
          >
            <div>
              {chatHistoryLoader ? (
                <div className="h-100">
                  <div className="loader text-center w-100 h-100">
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{
                            fontSize: 25,
                          }}
                          spin
                        />
                      }
                    />
                  </div>
                  {/* <p style={{ marginLeft: "20px" }}>Chat history loading...</p> */}
                </div>
              ) : chatTopicsHistoryList === "No results found." ? (
                <div className="h-100">
                  <p className="chat-history-not-found">No result found</p>
                </div>
              ) : chatTopicsHistoryList?.length ? (
                <>
                  {chatTopicsHistoryList?.map((topic, index) => {
                    return (
                      <Collapse
                        activeKey={activeKey}
                        key={index}
                        defaultActiveKey={index}
                        onChange={onChange}
                        bordered={false}
                        style={{ marginBottom: "-15px" }}
                      >
                        <Panel
                          showArrow={false}
                          header={
                            <span className="chat_topic_heading_container">
                              <p className="topic_heading">{topic.name}</p>
                              <img
                                src={
                                  activeKey.includes(index?.toString())
                                    ? downAccordian
                                    : chatNameAccordionIcon
                                }
                              />
                            </span>
                          }
                          key={index}
                        >
                          <div className="selected-chat-topic-name_container">
                            {topic?.content?.map((chat, chat_index) => {
                              return (
                                <div
                                  key={chat_index}
                                  className={`${
                                    showOptionPopUp?.flag &&
                                    showOptionPopUp?.index === chat_index &&
                                    showOptionPopUp?.text ===
                                      chat?.session_name &&
                                    showThreeDotIcon?.text_id ===
                                      chat?.session_id
                                      ? "selected-chat-topic-name"
                                      : selectedChatTopics?.session_id ===
                                        chat?.session_id
                                      ? "selected-chat-topic-name"
                                      : "chat-topic-name"
                                  }`}
                                  // onClick={() => handleGetTopicChats(chat)}
                                  onMouseEnter={() =>
                                    handleOnMouseEnter(
                                      chat_index,
                                      chat?.session_name,
                                      chat?.session_id
                                    )
                                  }
                                  onMouseLeave={() =>
                                    handleOnMouseLeave(
                                      chat_index,
                                      chat?.session_name,
                                      chat?.session_id
                                    )
                                  }
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-around",
                                    }}
                                  >
                                    {enabledEditChat?.flag &&
                                    enabledEditChat?.session_id ===
                                      chat?.session_id ? (
                                      <>
                                        <input
                                          className="edited-chat-topic-name"
                                          value={editedChatName}
                                          onChange={(e) =>
                                            setEditedChatName(e?.target?.value)
                                          }
                                          onKeyDown={(e) =>
                                            handleEditedChatNameAPICall(e)
                                          }
                                          autoFocus
                                          maxlength="100"
                                        />
                                      </>
                                    ) : (
                                      <Tooltip
                                        placement="right"
                                        title={chat?.session_name}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                          onClick={() =>
                                            handleGetTopicChats(chat)
                                          }
                                        >
                                          {chat?.session_name}
                                        </div>
                                      </Tooltip>
                                    )}
                                    {!enabledEditChat?.flag &&
                                    showThreeDotIcon?.flag &&
                                    showThreeDotIcon?.index === chat_index &&
                                    showThreeDotIcon?.text ===
                                      chat?.session_name &&
                                    showThreeDotIcon?.text_id ===
                                      chat?.session_id ? (
                                      <>
                                        <div
                                          className="chat-topic-name-options"
                                          onClick={() =>
                                            handleOpenChatOptionPopUp(
                                              chat_index,
                                              chat?.session_name,
                                              chat,
                                              chat?.session_id
                                            )
                                          }
                                        >
                                          <Popover
                                            content={optionsContent}
                                            trigger="click"
                                            placement="right"
                                            open={
                                              showCustomModal?.flag
                                                ? false
                                                : showOptionPopUp?.flag
                                            }
                                            onOpenChange={handlePopUpVisible}
                                          >
                                            <img
                                              style={{
                                                padding: "0px 12px 0px 12px",
                                              }}
                                              src={threeDotIcon}
                                              alt="three Dot Icon"
                                            />
                                          </Popover>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </Panel>
                      </Collapse>
                    );
                  })}
                </>
              ) : (
                <p className="chat-history-not-found">Chat history not found</p>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="upgrade-plan-button-container">
          {is_locobuzz_user === "true" ? (
            ""
          ) : is_subscription_active === "true" ? (
            ""
          ) : (
            <Tooltip title={""}>
              <span>
                <Button
                  className="upgrade-plan-button"
                  onMouseEnter={handleOnMouseEnter1}
                  onMouseLeave={handleOnMouseLeave1}
                  onClick={handleUpgradePlan}
                  // disabled //disabling temporarily
                >
                  <img src={BoltIcon} alt="BoltIcon" />
                  {upgradePlanText}
                </Button>
              </span>
            </Tooltip>
          )}
          {/* <Button
            className="clear-all-chat-button"
            onClick={chatTopicsHistoryList?.length && handleClearAllChat}
          >
            Clear all
          </Button> */}
        </div>

        {showCustomModal?.flag ? (
          <CustomModal
            isModalOpen={showCustomModal?.flag}
            setShowCustomModal={setShowCustomModal}
            title={showCustomModal?.title}
            sub_title={showCustomModal?.sub_title}
            option={showCustomModal?.option}
            session_id={chatSessionId}
            setShowOptionPopUp={setShowOptionPopUp}
            setShowThreeDotIcon={setShowThreeDotIcon}
          />
        ) : (
          ""
        )}

        {/* Search Modal */}
        {searchModalEnabled ? (
          <SearchModal
            isModalOpen={searchModalEnabled}
            setSearchModalEnabled={setSearchModalEnabled}
          />
        ) : (
          ""
        )}
      </section>
    </>
  );
};

export default React.memo(SideBar, isEqual);
